export default "__VITE_ASSET__CLbmLZNS__"